import moment from 'moment';



export const toDate = (timestamp, { order = 'ymd', delim = '-' } = {}) => {
    const dt = new Date(timestamp * 1000);
    const year = dt.getFullYear();
    const month = ('0' + (dt.getMonth() + 1)).slice(-2);
    const day = ('0' + dt.getDate()).slice(-2);

    // Create a mapping for order variations
    const dateMap = {
        'ymd': [year, month, day],
        'mdy': [month, day, year],
        'dmy': [day, month, year]
    };

    // Ensure order parameter is valid
    if (!dateMap[order]) {
        throw new Error(`Invalid order parameter: ${order}`);
    }

    return dateMap[order].join(delim);
};

export const toDateTime = (timestamp)=>{
    let dt = new Date(timestamp*1000);
    let year = dt.getFullYear();
    let month = ('0' + (dt.getMonth() + 1)).slice(-2); // Months are zero-based
    let day = ('0' + dt.getDate()).slice(-2);
    let hour = ('0' + dt.getHours()).slice(-2);
    let minute = ('0' + dt.getMinutes()).slice(-2);
    return `${year}/${month}/${day} ${hour}:${minute}`;
}


/**
 * Get the number of days between two unix timestamps
 * @param timestamp1
 * @param timestamp2
 * @returns {number}
 */
export const getDeltaDaysFromTimestamps = (timestamp1, timestamp2)=>{
  // Calculate the difference in milliseconds
  const diffInMilliseconds = Math.abs(timestamp2 - timestamp1);

  // Convert milliseconds to days
  const diffInDays = diffInMilliseconds / (1000 * 60 * 60 * 24);

  // Round the result to a desired number of decimal places (e.g., 2)
  const decimalDays = Math.round(diffInDays * 100) / 100;

  return decimalDays;
}



const isWeekday = (date) => {
  const day = date.day();
  return day !== 0 && day !== 6;
};

// Function to create a future date range with weekdays only
export const createFutureDateRange = (n, unit='days') => {
  const dates = [];
  let currentDate = moment();

  while (dates.length < n) {
    currentDate = currentDate.add(1, unit);
    if (isWeekday(currentDate)) {
      dates.push(currentDate.format('YYYY-MM-DD'));
    }
  }

  return dates;
};

export function getDateFromLookback(amount, unit) {
  const today = new Date();
  let newDate = new Date(today); // Create a copy to avoid modifying the original

  switch (unit) {
    case 'day':
      newDate.setDate(today.getDate() - amount);
      break;
    case 'week':
      newDate.setDate(today.getDate() - (amount * 7));
      break;
    case 'month':
      newDate.setMonth(today.getMonth() - amount);
      break;
    case 'year':
      newDate.setFullYear(today.getFullYear() - amount);
      break;
    default:
      throw new Error('Invalid unit provided. Please use "day", "week", "month", or "year".');
  }

  // Format the date as YYYY-MM-DD
  const year = newDate.getFullYear();
  const month = ('0' + (newDate.getMonth() + 1)).slice(-2); // Add leading zero if needed
  const day = ('0' + newDate.getDate()).slice(-2); // Add leading zero if needed
  return `${year}-${month}-${day}`;
}


export const getAge = (date) => {
 // Handle Unix timestamp (seconds or milliseconds)
 const timestamp = typeof date === 'number'
   ? new Date(date < 10000000000 ? date * 1000 : date)
   : new Date(date);

 const today = new Date();
 let age = today.getFullYear() - timestamp.getFullYear();

 // Adjust age if birthday hasn't occurred this year
 if (today.getMonth() < timestamp.getMonth() ||
     (today.getMonth() === timestamp.getMonth() &&
      today.getDate() < timestamp.getDate())) {
   age--;
 }

 return age;
};


export function removeDuplicateTimestamps(arr) {
    // Use a Map to keep track of seen timestamps, storing the first object for each timestamp
    const timestampMap = new Map();

    // Iterate through array and only keep first occurrence of each timestamp
    arr.forEach(obj => {
        if (!timestampMap.has(obj.timestamp)) {
            timestampMap.set(obj.timestamp, obj);
        }
    });

    // Convert Map values back to array
    return Array.from(timestampMap.values());
}

